{
  "eyebrow": "Crea tu cuenta",
  "title": "Unos datos sobre tu empresa.",
  "sub": "Serás el administrador principal. Podrás invitar a más administradores después de la configuración.",
  "company": "Empresa",
  "companyName": "Nombre de la empresa",
  "companyVat": "Número de IVA",
  "companyVatBssHint": "Necesario para las declaraciones a la Seguridad Social belga (DIMONA).",
  "companyCountry": "País",
  "companySector": "Sector",
  "companySectorPlaceholder": "Elige tu sector",
  "sectors": {
    "construction": "Servicios de construcción",
    "cleaning": "Servicios de limpieza",
    "business": "Servicios empresariales",
    "horticulture": "Servicios de horticultura",
    "other": "Otros servicios"
  },
  "admin": "Administrador principal",
  "adminFirst": "Nombre",
  "adminLast": "Apellidos",
  "adminEmail": "Email de trabajo",
  "adminPhone": "Teléfono",
  "adminPw": "Contraseña",
  "adminPwHint": "Al menos 10 caracteres y un número.",
  "adminPwShow": "Mostrar contraseña",
  "adminPwHide": "Ocultar contraseña",
  "terms": {
    "pre": "Acepto los",
    "t": "Términos de servicio",
    "and": "y la",
    "p": "Política de privacidad"
  },
  "cta": "Crear cuenta y continuar",
  "errors": {
    "required": "Obligatorio",
    "tooShort": "Demasiado corto",
    "invalidEmail": "Introduce un email válido",
    "invalidVat": "Introduce un número de IVA válido",
    "invalidBelgianVat": "Introduce un número de IVA belga válido (p. ej., BE0123456789).",
    "invalidPhone": "Introduce un teléfono válido",
    "passwordWeak": "Al menos 12 caracteres con un número",
    "termsRequired": "Debes aceptar los términos",
    "emailExists": "Este email ya está en uso",
    "vatRequiredForBss": "El IVA es obligatorio para la Seguridad Social belga",
    "network": "Error de red o del servidor. Inténtalo de nuevo.",
    "throttled": "Demasiados intentos. Inténtalo de nuevo en {{minutes}} min."
  },
  "verify": {
    "awaitingTitle": "Revisa tu bandeja de entrada",
    "awaitingSub": "Enviamos un enlace de verificación a {{email}}. Haz clic para activar tu cuenta e iniciar tu prueba gratuita.",
    "awaitingSubNoEmail": "Te enviamos un enlace de verificación. Haz clic para activar tu cuenta e iniciar tu prueba gratuita.",
    "resend": "Reenviar email",
    "resendCooldown": "Reenviar en {{seconds}}s",
    "verifyingTitle": "Verificando…",
    "successTitle": "¡Tu prueba gratuita de 30 días ha comenzado!",
    "successSub": "No se necesita tarjeta de crédito. Inicia sesión en tu panel para empezar a usar Done-it.",
    "errorTitle": "No pudimos verificar el enlace",
    "errorSub": "Es posible que el enlace haya expirado. Empieza de nuevo desde los datos de tu cuenta.",
    "errorCta": "Volver a la cuenta",
    "interstitial": "Verificación de email",
    "subscribedTitle": "Tu cuenta está lista",
    "subscribedSub": "El pago ya está completado. Inicia sesión en tu panel para empezar a usar Done-it.",
    "subscribedCta": "Iniciar sesión en el panel",
    "successCta": "Abrir el panel",
    "successNote": "Recibirás algunos correos útiles durante tu prueba y un enlace para suscribirte cerca del final.",
    "awaitingSubFree": "Enviamos un enlace de verificación a {{email}}. Haz clic para activar tu cuenta gratuita: Time Zero es gratis para siempre, sin tarjeta de crédito.",
    "awaitingSubFreeNoEmail": "Te enviamos un enlace de verificación. Haz clic para activar tu cuenta gratuita: Time Zero es gratis para siempre, sin tarjeta de crédito.",
    "successTitleFree": "¡Tu cuenta gratuita está lista!",
    "successNoteFree": "Time Zero es gratis para siempre dentro de sus límites. Mejora tu plan cuando quieras para un uso ilimitado."
  }
}
